import LabeledCheckbox from '@/components/v3/LabeledCheckbox.jsx';

const WizardCheckbox = ({ ...props }) => {
  return <LabeledCheckbox {...props} />;
};

export default WizardCheckbox;
